import {Box, Card, CardContent, Chip, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import WorkingHours from "../components/working-hours";

export default function CompanyOperations({distributor, onWorkingHoursUpdate}) {
    const {t} = useTranslation();
    return <Card variant="outlined" sx={{mt: 3}}><CardContent>
        <Typography variant="h6" sx={{mb: 2}}>{t("BusinessHours")}</Typography>
        <WorkingHours tenant={distributor} editable onUpdate={onWorkingHoursUpdate}/>
        <Grid container spacing={3} sx={{mt: 1}}>
            {[{title: "OurServices", values: distributor.services}, {title: "Specializations", values: distributor.specializations}]
                .map(({title, values}) => <Grid item xs={12} md={6} key={title}>
                    <Typography variant="subtitle1" sx={{mb: 1}}>{t(title)}</Typography>
                    {values?.length ? <Box display="flex" flexWrap="wrap" gap={1}>
                        {values.map(value => <Chip key={value} label={value} variant="outlined"/>)}</Box>
                        : <Typography variant="body2" color="text.secondary">{t("SoonAvailable")}</Typography>}
                </Grid>)}
        </Grid>
    </CardContent></Card>;
}
